import { connect } from "react-redux";

const Campaign = (props) => {
   const { carts } = props;
   return (
      <div className="info-campaign-wrapper order-confirm">
         <div>
            <div className="svg-next-icon icon-status icon-shipping-line">
            </div>
         </div>
         <span className="title">
            {carts.campaign_name}
         </span>
      </div>
   )
}

const mapStateToProps = (state) => {
   const { carts } = state;
   return {
      carts
   };
};

export default connect(mapStateToProps, {
})(Campaign)
